import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'translate',
    standalone: false
})
export class TranslateMockPipe implements PipeTransform {
  transform(value: string): string {
    // Do stuff here, if you want
    return value;
  }
}
